module.exports = __webpack_public_path__ + "img/20200508_173909.fd7dcf01.jpg";